import manualsolutionModal from './../../views/common/manualsolutionModal.html'
import utils from 'utils'
class selectManualSolution {
    constructor(logger, httpRequest, $uibModal) {
        function isToday(dateString) {
            // 解析传入的日期字符串
            const inputDate = new Date(dateString);

            // 获取当前日期
            const today = new Date();

            // 比较年月日是否相同
            return inputDate.getFullYear() === today.getFullYear() &&
                inputDate.getMonth() === today.getMonth() &&
                inputDate.getDate() === today.getDate();
        }

        this.getResult = async function () {
            let setInfo
            await httpRequest.get_getUserCustomizedInfo(1000).then(res => {
                setInfo = res.data.value||{}
            })
            if (isToday(setInfo&&setInfo.updateTime)) {
                return true
            } else {
                return await $uibModal
                    .open({
                        template: manualsolutionModal,
                        openedClass: 'mod-modal mod-modal-hg',
                        controller: [
                            '$scope',
                            '$uibModalInstance',
                            '$timeout',
                            'diskConfig',
                            'httpRequest',
                            function ($scope, $uibModalInstance, $timeout, diskConfig, httpRequest) {
                                if (diskConfig) {
                                    $scope.manualTag = diskConfig
                                } else {
                                    $scope.manualTag = '0'
                                }

                                // httpRequest.get_getUserCustomized(1000).then(res => {

                                //     if (res.data.value) {
                                //         $scope.manualTag = res.data.value
                                //     } else {
                                //         $scope.manualTag = '0'
                                //     }
                                // })

                                $scope.ok = function () {
                                    utils.loading('请求已发送')
                                    httpRequest.post_saveUserCustomized({
                                        profileInfo: JSON.stringify(
                                            Number($scope.manualTag)),
                                        profileType: '1000',
                                    }).then(res => {
                                        utils.loaded()
                                        logger.logSuccess('保存成功')
                                        $uibModalInstance.close()

                                    })

                                }
                                $scope.cancel = function () {
                                    $uibModalInstance.dismiss('cancel')
                                }
                            },
                        ],
                        animation: true,
                        resolve: {
                            diskConfig() {
                                return setInfo.profileInfo||'0'
                            },
                        },
                    })
                    .result.then((obj) => {
                        return true
                    }, () => {
                        return false
                    })
            }
        }


        this.onScrollTop = function (currentDetail, pageParam, loadSize, cb) {
            const detail = currentDetail
            let returnPageParam = pageParam
            if (detail.hasPreviousPage) { // 存在上一页 
                const currentPageNum = detail.pageNum
                const startPoint = (currentPageNum - 1) * loadSize - loadSize // 正常情况下起始点
                const endPoint = (currentPageNum - 1) * loadSize > detail.total ? detail.total : (currentPageNum - 1) * loadSize
                const msg = `正在加载${startPoint + 1}-${endPoint}条商品明细,共${detail.total}条`
                utils.loading(msg)
                returnPageParam.pageNum = detail.prePage
                cb(returnPageParam)
                $scope.$apply()
                setTimeout(() => {
                    $('.slimScrollBar').css({
                        top: 0.5,
                    })
                    utils.loaded()
                }, 2000)
            } else {
                console.log('到顶啦！！')
            }
            return returnPageParam
        }
        this.onScrollDown = function (currentDetail, pageParam, loadSize, cb) {
            const detail = currentDetail
            let returnPageParam = pageParam
            if (detail.hasNextPage) { // 存在下一页 
                const currentPageNum = detail.pageNum
                const startPoint = (currentPageNum + 1) * loadSize - loadSize // 正常情况下起始点
                let endPoint = (currentPageNum + 1) * loadSize
                if ((currentPageNum + 1) * loadSize > detail.total) { // 总条数小于endpoint
                    endPoint = detail.total
                }
                if (detail.total < currentPageNum * loadSize + 20) { // 总条数大于endpoint但是小于endpoint+20(大于20条才会出现滚动条)
                    endPoint = detail.total
                }

                const msg = `正在加载${startPoint + 1}-${endPoint}条商品明细,共${detail.total}条`
                utils.loading(msg)
                returnPageParam.pageNum = detail.nextPage
                cb(returnPageParam)
                $scope.$apply()
                console.log($('.slimScrollBar'))
                setTimeout(() => {
                    if (detail.total < (loadSize * currentPageNum + 20)) {
                        $('.slimScrollBar').css({
                            bottom: 8,
                        })
                    } else {
                        $('.slimScrollBar').css({
                            top: 0.5,
                        })
                    }
                    utils.loaded()
                }, 2000)
            } else {
                console.log('到底啦！！')
            }
            return returnPageParam
        }
    }
}

selectManualSolution.$inject = ['logger', 'httpRequest', '$uibModal']
export default selectManualSolution



// WEBPACK FOOTER //
// ./src/common/services/selectManualSolution.js